import { FlatTreeControl } from "@angular/cdk/tree";
import { Component, OnInit, ViewChild } from "@angular/core";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import {
  MatTreeFlatDataSource,
  MatTreeFlattener,
} from "@angular/material/tree";
import { DataSharingService } from "../../AuthGuard/DataSharingService";
import { MasterService } from "../../Shared/app.Masters.Service";
import { LmsService } from "../../_Lms/services/lms.service";
import { ReportsService } from "../services/reports.service";
import * as moment from "moment";
declare var $: any;

interface ParReport {
  Name: string;
  children?: ParReport[];
  ViewDetail: string;
}

interface ParReportFlatNode {
  expandable: boolean;
  Name: string;
  level: number;
  ViewDetail: string;
}

@Component({
    selector: "app-par-report",
    templateUrl: "./par-report.component.html",
    styleUrls: ["./par-report.component.scss"],
    standalone: false
})
export class ParReportComponent implements OnInit {
  showSpinner: boolean = false;
  currentUser: any;
  SlabData: any[] = [];
  Div_Branch: boolean = false;
  Div_Product: boolean = false;
  Div_CollectionExecutive: boolean = false;
  DataSource: any;
  Selectname: any;
  AmtType: any = "OD_Amount";
  partext: any[] = [];
  partextDetail: any[] = [];
  //Form value
  SlabId: any = "";
  ToDate: any = new Date();
  SearchBy: any = "Branch";
  BranchId: any = 0;
  ProductId: any = 0;
  CollexecId: any = 0;
  SelectBranch: any[] = [];
  SelectProduct: any[] = [];
  SelectCollectionExecutive: any[] = [];
  BranchesList: any = [];
  ProductList: any = [];
  CollectionExecutiveList: any = [];
  branchDropdownSettings: any = {};
  productDropdownSettings: any = {};
  collectionExecutiveDropdownSettings: any = {};
  div_modalOut = false;
  TREE_DATA: ParReport[] = [];
  displayTreeColumns: string[] = [];
  displayTreeColumnsDetail: string[] = [];
  div_tree: boolean = false;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild("Paginglistmodel", { read: MatPaginator })
  Paginglistmodel: MatPaginator;

  constructor(
    private _MasterService: MasterService,
    private dataSharingService: DataSharingService,
    private lmsService: LmsService,
    private reportsService: ReportsService

  ) {}
  hasChild = (_: number, node: ParReportFlatNode) => node.expandable;

  ngOnInit() {
    this.dataSharingService.HeaderTitle.next("PAR Report");
    this.currentUser = JSON.parse(sessionStorage.getItem("currentUser"));
    this.getSlabsList("DPD");
    this.getBranchesList();
    this.getProductDropdown();
    this.initializeDropdownSettings();
    this.SearchByChange();
  }

  treeControl = new FlatTreeControl<ParReportFlatNode>(
    (node) => node.level,
    (node) => node.expandable
  );
  private transformer = (node: ParReport, level: number) => {
    return {
      expandable: !!node.children && node.children.length > 0,
      Name: node.Name,

      level: level,
      ViewDetail: node.ViewDetail,
    };
  };
  treeFlattener = new MatTreeFlattener(
    this.transformer,
    (node) => node.level,
    (node) => node.expandable,
    (node) => node.children
  );

  dataSourceTree: any = new MatTreeFlatDataSource(
    this.treeControl,
    this.treeFlattener
  );
  dataSourceTreeDetail: any;
  dataSourceTreeDetailModel: any = null;
  SearchByChange() {
    if (this.SearchBy == "Branch") {
      this.Div_Branch = true;
      this.Div_Product = false;
      this.Div_CollectionExecutive = false;
      this.SelectProduct = [];
      this.ProductId = 0;
      this.getBranchesList();
    } else if (this.SearchBy == "Product") {
      this.Div_Product = true;
      this.Div_Branch = false;
      this.Div_CollectionExecutive = false;
      this.SelectBranch = [];
      this.BranchId = 0;
      this.getProductDropdown();
    } 
    // Keep the group-by token aligned with the HTML option value so the executive filter can render.
    else if (this.SearchBy == "Collection Exe") {
      this.Div_CollectionExecutive = true;
      this.Div_Branch = false;
      this.Div_Product = false;
      this.SelectBranch = [];
      this.SelectProduct = [];
      this.BranchId = 0;
      this.ProductId = 0;
      this.getCollectionExecutiveDropdown();
    } 
    else {
      this.Div_Branch = false;
      this.Div_Product = false;
      this.Div_CollectionExecutive = false;
      this.SelectBranch = [];
      this.SelectProduct = [];
      this.SelectCollectionExecutive = [];
      this.BranchId = 0;
      this.ProductId = 0;
      this.CollexecId = 0;
    }
  }

  initializeDropdownSettings() {
    this.branchDropdownSettings = {
      singleSelection: false,
      idField: "BranchId",
      textField: "Branch_Name",
      selectAllText: "Select All",
      unSelectAllText: "Deselect All",
      allowSearchFilter: true,
      itemsShowLimit: 1,
      showSelectedItemsAtTop: true,
    };

    this.productDropdownSettings = {
      singleSelection: false,
      idField: "ProductId",
      textField: "Product",
      selectAllText: "Select All",
      unSelectAllText: "Deselect All",
      allowSearchFilter: true,
      itemsShowLimit: 1,
      showSelectedItemsAtTop: true,
    };

    this.collectionExecutiveDropdownSettings = {
    singleSelection: false,
    // The collection executive dropdown is bound to the LMS executive list shape.
    idField: "EmpId",
    textField: "Emp_FirstName",  
    selectAllText: "Select All",
    unSelectAllText: "Deselect All",
    allowSearchFilter: true,
    itemsShowLimit: 1,
    showSelectedItemsAtTop: true,
};
  }

  getProductDropdown() {
    this.ProductList = [];
    this._MasterService
      .GetProductList({ Emp_Id: this.currentUser.userId })
      .subscribe((result) => {
        this.ProductList = JSON.parse(JSON.stringify(result));
      });
  }
  getCollectionExecutiveDropdown() {
    this.CollectionExecutiveList = [];
    // Load collection executives from the LMS dropdown API used across other LMS reports.
    this.lmsService
      .Get_Lms_CollectionExecutive({
        Branch_Id: 0,
      })
      .subscribe((result) => {
        this.CollectionExecutiveList = JSON.parse(JSON.stringify(result));
      });
  }

  onCollectionExecutiveSelectionChange() {
  this.CollectionExecutiveList = this.moveSelectedItemsToTop(
    this.CollectionExecutiveList,
    this.SelectCollectionExecutive,
    "EmpId" 
  );
}
  getBranchesList() {
    this.BranchesList = [];
    this.lmsService
      .GetBranches({ Emp_Id: this.currentUser.userId })
      .subscribe((result) => {
        this.BranchesList = JSON.parse(JSON.stringify(result));
      });
  }

  getSelectedIds(items: any[], key: string): string {
    return items?.map((item) => item[key]).join(",") || "";
  }

  moveSelectedItemsToTop(
    items: any[],
    selectedItems: any[],
    key: string
  ): any[] {
    if (!items?.length) {
      return [];
    }

    const selectedIds = new Set(
      (selectedItems || []).map((item) => String(item[key]))
    );

    const selected = items.filter((item) => selectedIds.has(String(item[key])));
    const unselected = items.filter(
      (item) => !selectedIds.has(String(item[key]))
    );

    return [...selected, ...unselected];
  }

  onBranchSelectionChange() {
    this.BranchesList = this.moveSelectedItemsToTop(
      this.BranchesList,
      this.SelectBranch,
      "BranchId"
    );
  }

  onProductSelectionChange() {
    this.ProductList = this.moveSelectedItemsToTop(
      this.ProductList,
      this.SelectProduct,
      "ProductId"
    );
  }

  getSlabsList(Slab_Type) {
    this._MasterService
      .Get__Slab_dropdown({
        Type: Slab_Type,
        LoginUserId: this.currentUser.userId,
      })
      .subscribe((result) => {
        this.SlabData = JSON.parse(JSON.stringify(result));
      });
  }
  public GetInterfaceData() {
    return this._MasterService.Get_Report_Slab_Config({
      Id: this.SlabId,
      Type: "DPD",
      LoginUserId: this.currentUser.userId,
    });
  }
  GetParTextData() {
    // this.GetInterfaceData();
    this.partext = ["Name", "NoOfLoans"];
    this.displayTreeColumns = this.partext;

    this.partextDetail = ["LoanAcNo"];
    this.partextDetail = ["Loan_Date"];
    this.partextDetail = ["CustomerName"];

    this.displayTreeColumnsDetail = [
      "Id",
      "LoanAcNo",
      "Loan_Date",
      "CustomerName",
    ];
    this._MasterService
      .Get_Report_Slab_Config({
        Id: this.SlabId,
        Type: "DPD",
        LoginUserId: this.currentUser.userId,
      })
      .subscribe((res: any) => {
        //console.log("res", res);
        for (var i = 0; i < res.length; i++) {
          this.partext.push("A" + res[i].Slab);
          this.displayTreeColumnsDetail.push("A" + res[i].Slab);

          this.partext.push("C" + res[i].Slab);
          //this.displayTreeColumnsDetail.push(
          //  "C" + res[i].Slab,
          //);
        }
        this.displayTreeColumns[this.displayTreeColumns.length] = "Action";
      });
    console.log("this.displayTreeColumnsDetail", this.displayTreeColumnsDetail);
  }

  onSearchParReportData() {
    if (this.SearchBy == 'AmountWise' || 
      this.SearchBy == 'TenureWise' || 
      this.SearchBy == 'IRRWise'    || 
      this.SearchBy == 'LTVWise') {

    this.showSpinner = true;
    this.reportsService.SlabWise_Report_PAR({
    ToDate: this.ToDate,
    SlabId: Number(this.SlabId),
    search: this.SearchBy,
    Amount_Type: this.AmtType
  }).subscribe((res: any) => {
    this.showSpinner = false;
    console.log(res);

  if (res && res.length > 0) {
    const keys = Object.keys(res[0]);
    // this.displayTreeColumns = keys;
    this.displayTreeColumns = keys.filter(k => k !== 'Id');  // ← Id hide
    this.displayTreeColumns.push('Action'); 
    this.dataSourceTree = res;
    this.dataSourceTreeDetailModel = null;
    this.div_tree = true;
  }
});

  } else {
    this.showSpinner = true;
    this.BranchId = this.SearchBy == "Branch" 
    ? this.getSelectedIds(this.SelectBranch, "BranchId") || "" 
    : "";
    
  this.ProductId = this.SearchBy == "Product" 
    ? this.getSelectedIds(this.SelectProduct, "ProductId") || "" 
    : "";

    // Pass the selected collection executive only when Collection Executive grouping is active.
    this.CollexecId = this.SearchBy == "Collection Exe"
      ? this.getSelectedIds(this.SelectCollectionExecutive, "EmpId") || ""
      : "";

    this.reportsService
      .Report_PAR({
        To: this.ToDate,
        SlabId: Number(this.SlabId),
        SearchBy: this.SearchBy,
        Branch_Id: this.BranchId,
        ProductId: this.ProductId,
        CollexecId: this.CollexecId,
        Amount_Type: this.AmtType,
      })
      .subscribe((res: any) => {
        this.GetParTextData();
        this.dataSourceTree = res;
        this.dataSourceTreeDetailModel = null;
        this.showSpinner = false;
        this.div_tree = true;
      });
    }
  }
  onReport_PAR_Detail(data) {
  this.showSpinner = true;
  if (this.SearchBy == 'AmountWise' || 
      this.SearchBy == 'TenureWise' || 
      this.SearchBy == 'IRRWise'    || 
      this.SearchBy == 'LTVWise') {

    this.Selectname = data.SlabName;

    this.reportsService.Report_PAR_Detail({
      To: this.ToDate,
      SlabId: Number(this.SlabId),
      SearchBy: this.SearchBy,
      Branch_Id: '0',
      ProductId: '0',
      CollectionExecutive: 0,
      SlabRowId: data.Id,
      Amount_Type: this.AmtType
    }).subscribe((res: any) => {
      if (res && res.length > 0) {
        this.displayTreeColumnsDetail = Object.keys(res[0] || {}).filter((key) => key !== "Loan_Id");
        this.div_tree = true;
        this.dataSourceTreeDetail = null;
        this.dataSourceTreeDetailModel = new MatTableDataSource(res);
        this.dataSourceTreeDetailModel.paginator = this.Paginglistmodel;
        $("#ViewParDetails").modal("show");
        $("#ViewParDetails").css("z-index", "1050");
      } else {
        this.dataSourceTreeDetailModel = null;
      }
      this.showSpinner = false;
    });

  } else { 
    this.showSpinner = true;
    this.Selectname = data.Name;
    let Branch_Id: string = this.SearchBy == "Branch" ? String(data.Id) : "0";
    let ProductId: string = this.SearchBy == "Product" ? String(data.Id) : "0";
    let CollectionExecutive: string = this.SearchBy == "Collection Exe" ? String(data.Id) : "0";

    this.reportsService.Report_PAR_Detail({
      To: this.ToDate,
      SlabId: Number(this.SlabId),
      SearchBy: this.SearchBy,
      Branch_Id: Branch_Id,             
      ProductId: ProductId,             
      CollectionExecutive: CollectionExecutive,
      Amount_Type: this.AmtType,
    }).subscribe((res: any) => {
      if (res.length > 0) {
        if (this.SearchBy != "") {
          this.div_tree = true;
          this.dataSourceTreeDetail = null;
          this.dataSourceTreeDetailModel = new MatTableDataSource(res);
          this.dataSourceTreeDetailModel.paginator = this.Paginglistmodel;
          this.GetInterfaceData().subscribe((res: any) => {
            this.displayTreeColumnsDetail = ["Id", "LoanAcNo", "Loan_Date", "CustomerName"];
            for (var i = 0; i < res.length; i++) {
              this.displayTreeColumnsDetail.push("A" + res[i].Slab);
            }
            // this.div_tree = false;
            this.div_modalOut = true;
          });
          $("#ViewParDetails").modal("show");
          $("#ViewParDetails").css("z-index", "1050");
        } else {
          this.dataSourceTreeDetailModel = null;
          this.dataSourceTreeDetail = new MatTableDataSource(res);
          this.dataSourceTreeDetail.paginator = this.paginator;
          this.GetInterfaceData().subscribe((res: any) => {
            this.displayTreeColumnsDetail = ["Id", "LoanAcNo", "Loan_Date", "CustomerName"];
            for (var i = 0; i < res.length; i++) {
              this.displayTreeColumnsDetail.push("A" + res[i].Slab);
            }
            this.div_tree = false;
            this.div_modalOut = true;
          });
        }
        this.showSpinner = false;
      } else {
        this.dataSourceTreeDetail = null;
        this.dataSourceTreeDetailModel = null;
        this.showSpinner = false;
      }
    });
  }
}  
  onCloseParDetail() {
    this.Selectname = "";
    $("#ViewParDetails").modal("hide");
  }
  unflatten(arr) {
    var tree = [],
      mappedArr = {},
      arrElem,
      mappedElem;
    let sh;
    // First map the nodes of the array to an object -> create a hash table.
    for (var i = 0, len = arr.length; i < len; i++) {
      arrElem = arr[i];
      mappedArr[arrElem.Id] = arrElem;
      mappedArr[arrElem.Id]["children"] = [];
    }

    for (var Id in mappedArr) {
      if (mappedArr.hasOwnProperty(Id)) {
        mappedElem = mappedArr[Id];
        // If the element is not at the root level, add it to its parent array of children.
        if (mappedElem.ParentId) {
          mappedArr[mappedElem["ParentId"]]["children"].push(mappedElem);
        }
        // If the element is at the root level, add it to first level elements array.
        else {
          tree.push(mappedElem);
        }
      }
    }
    return tree;
  }

  exportTable(exporter: any, Type) {
    var Title = Type == "Summary" ? "Par-Report-Summary" : "Par-Report-Details";
    exporter.exportTable("xls", {
      fileName: Title,
      sheet: Title,
    });
  }

  totaltypewise(type) {
    //   console.log("dataSourceTree", this.dataSourceTree.filteredData)
    if (type != "Name" && type != "Action") {
      if (this.dataSourceTree != null) {
        let sum = 0;
        for (let i = 0; i < this.dataSourceTree.length; i++) {
          sum += Number(this.dataSourceTree[i][type]);
        }
        return sum.toFixed(2);
      }
    }
    return "Total";
  }

  totaltypewiseDetails(type) {
    if (type == "Id" || type == "LoanAcNo" || type == "Loan_Date") {
      return "";
    }

    if (type == "CustomerName") {
      return "Total";
    }

    if (this.dataSourceTreeDetail != null) {
      // console.log("under if condition");
      let sum = 0;
      for (let i = 0; i < this.dataSourceTreeDetail.filteredData.length; i++) {
        sum += Number(
          this.dataSourceTreeDetail.filteredData[i][type] == undefined
            ? 0
            : this.dataSourceTreeDetail.filteredData[i][type]
        );
      }
      // console.log("sum", sum);
      return sum.toFixed(2);
    } 
    return "";
  }
  totaltypewiseDetailsModel(type) {
    if (type == "Id" || type == "LoanAcNo" || type == "Loan_Date") {
      return "";
    }

    if (type == "CustomerName") {
      return "Total";
    }

    if (this.dataSourceTreeDetailModel != null) {
      // console.log("under if condition");
      let sum = 0;
      for (let i = 0; i < this.dataSourceTreeDetailModel.filteredData.length; i++) {
        sum += Number(
          this.dataSourceTreeDetailModel.filteredData[i][type] == undefined
            ? 0
            : this.dataSourceTreeDetailModel.filteredData[i][type]
        );
      }
      // console.log("sum", sum);
      return sum.toFixed(2);
    }
    return "";
  }
  // totaltypewiseDetails(type) {
  //   //'Id','LoanAcNo', 'Loan_Date', 'CustomerName'
  //   if (type == "Id" || type == "LoanAcNo" || type == "Loan_Date") {
  //     return "";
  //   }
  //   if (type == "CustomerName") return "Total";

  //   console.log("Data source in total type", this.dataSourceTreeDetail);

  //   if (this.dataSourceTreeDetail != null) {
  //     let sum = 0;
  //     // for (let i = 0; i < this.dataSourceTreeDetail.length; i++) {
  //     //   sum += Number(this.dataSourceTreeDetail[i][type]);
  //     // }

  //     for (let i = 0; i < this.dataSourceTreeDetail.length; i++) {
  //       sum += Number(
  //         this.dataSourceTreeDetail[i][type]
  //         // ? 0
  //         // : this.dataSourceTreeDetail[i][type]
  //       );
  //     }

  //     return sum.toFixed(2);
  //   }
  //   return "";
  // }

  ChangeAmt() {
    this.div_tree = false;
    this.div_modalOut = false;
    this.dataSourceTree = new MatTableDataSource([]);
  }

  applyFilter(filterValue: string) {
    this.dataSourceTreeDetail.filter = filterValue.trim().toLowerCase();
  }

  applyFilterModal(filterValue: string) {
    this.dataSourceTreeDetailModel.filter = filterValue.trim().toLowerCase();
  }
exportParSummary(): void {
  const uri = "data:application/vnd.ms-excel;base64,";
  const template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--><style>td{mso-number-format:General;}</style></head><body><table>{table}</table></body></html>';
  const base64 = (s: string): string => window.btoa(unescape(encodeURIComponent(s)));
  const format = (s: string, c: { [key: string]: string }): string => s.replace(/{(\w+)}/g, (m, p) => c[p]);

  let tableHTML = '<tr>';

  this.displayTreeColumns.forEach(col => {
    if (col === 'Action') return;
    const header = col === 'Name' ? 'Name' : col === 'NoOfLoans' ? 'Total Loans' : col === 'TotalAmount' ? 'Total Amount' : col.split('A').join('');
    tableHTML += `<th style="background:var(--theme-primary);color:white;border:1px solid white;font-weight:bold">${header}</th>`;
  });
  tableHTML += '</tr>';

  let totalNoOfLoans = 0;
  const totals: any = {};

  if (this.dataSourceTree && this.dataSourceTree.length > 0) {
    this.dataSourceTree.forEach((row: any) => {
      tableHTML += '<tr>';
      this.displayTreeColumns.forEach(col => {
        if (col === 'Action') return;
        if (col === 'Name') {
          tableHTML += `<td>${row[col] || ''}</td>`;
        } else {
          const val = Number(row[col]) || 0;
          tableHTML += `<td>${val}</td>`;
          if (col === 'NoOfLoans') totalNoOfLoans += val;
          else totals[col] = (totals[col] || 0) + val;
        }
      });
      tableHTML += '</tr>';
    });
  }

  // Changed by Codex: apply footer color on each exported cell so Excel does not extend the total-row background past real data columns.
  tableHTML += '<tr>';
  this.displayTreeColumns.forEach(col => {
    if (col === 'Action') return;
    if (col === 'Name') {
      tableHTML += '<td style="background:var(--theme-primary);color:white;font-weight:bold"><b>Total</b></td>';
    } else if (col === 'NoOfLoans') {
      tableHTML += `<td style="background:var(--theme-primary);color:white;font-weight:bold">${totalNoOfLoans}</td>`;
    } else {
      tableHTML += `<td style="background:var(--theme-primary);color:white;font-weight:bold">${totals[col] || 0}</td>`;
    }
  });
  tableHTML += '</tr>';

  const ctx = { worksheet: "PAR Summary", table: tableHTML };
  const downloadLink = document.createElement("a");
  const toDateStr = moment(this.ToDate).format("DD-MM-YYYY");
  downloadLink.href = uri + base64(format(template, ctx));
  downloadLink.download = `PAR_Summary_Report_${toDateStr}.xls`;
  downloadLink.click();
}

exportParDetail(): void {
  const uri = "data:application/vnd.ms-excel;base64,";
  const template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--><style>td{mso-number-format:General;}</style></head><body><table>{table}</table></body></html>';
  const base64 = (s: string): string => window.btoa(unescape(encodeURIComponent(s)));
  const format = (s: string, c: { [key: string]: string }): string => s.replace(/{(\w+)}/g, (m, p) => c[p]);
  const detailTextColumns = ["Id", "LoanAcNo", "Loan_Date", "CustomerName", "LoanId", "Loan_Id"];

  let tableHTML = '<tr>';

  this.displayTreeColumnsDetail.forEach(col => {
    if (col === 'Id') return;
    const header = col === 'LoanAcNo' ? 'Loan AcNo' : col === 'Loan_Date' ? 'Loan Date' : col === 'CustomerName' ? 'Customer Name' : col === 'TotalAmount' ? 'Total Amount' : col.split('A').join('');
    // Changed by Codex: keep detail export header color aligned with the footer green instead of the old red header.
    tableHTML += `<th style="background:var(--theme-primary);color:white;border:1px solid white;font-weight:bold">${header}</th>`;
  });
  tableHTML += '</tr>';

  let totals: any = {};

  const data = this.dataSourceTreeDetailModel ? this.dataSourceTreeDetailModel.data : (this.dataSourceTreeDetail ? this.dataSourceTreeDetail.data : []);

  data.forEach((row: any, i: number) => {
    tableHTML += '<tr>';
    this.displayTreeColumnsDetail.forEach(col => {
      if (col === 'Id') return;

      if (detailTextColumns.includes(col)) {
        tableHTML += `<td>${row[col] ?? ''}</td>`;
      } else {
        const val = Number(row[col]) || 0;
        tableHTML += `<td>${val}</td>`;
        totals[col] = (totals[col] || 0) + val;
      }
    });
    tableHTML += '</tr>';
  });

  // Changed by Codex: apply footer color on each exported cell so Excel does not extend the total-row background past real data columns.
  tableHTML += '<tr>';
  let firstCol = true;
  this.displayTreeColumnsDetail.forEach(col => {
    if (col === 'Id') return;
    if (firstCol) {
      tableHTML += '<td style="background:var(--theme-primary);color:white;font-weight:bold"><b>Total</b></td>';
      firstCol = false;
    } else if (col === 'CustomerName') {
      tableHTML += '<td style="background:var(--theme-primary);color:white;font-weight:bold"><b>Total</b></td>';
    } else {
      tableHTML += `<td style="background:var(--theme-primary);color:white;font-weight:bold">${totals[col] || 0}</td>`;
    }
  });
  tableHTML += '</tr>';

  const ctx = { worksheet: "PAR Details", table: tableHTML };
  const downloadLink = document.createElement("a");
  const toDateStr = moment(this.ToDate).format("DD-MM-YYYY");
  downloadLink.href = uri + base64(format(template, ctx));
  downloadLink.download = `PAR_Detail_Report_${toDateStr}.xls`;
  downloadLink.click();
}
}
